import { Injectable } from '@angular/core';
import { MessagesService } from './messages.service';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
    public keepLogin: boolean = false;
    
    private _keepLoginInterval: any = null;

    constructor(
        public messagesService: MessagesService
    ) {
        this.keepLogin = true;

        var keep_login = this.getItem("keep_login");
        if(keep_login && keep_login == "true"){
            this.keepLogin = true;
        }else{
            this.keepLogin = false;
        }
    }

    setItem(itemName: string, value: any){
        localStorage.setItem(itemName, value);
    }

    getItem(itemName: string): string{
        return localStorage.getItem(itemName);
    }

    removeItem(itemName: string){
        localStorage.removeItem(itemName);
    }

    clear(){
        localStorage.clear();
        clearInterval(this._keepLoginInterval);
        this._keepLoginInterval = null;
    }

    initialiseLoginInterval(){
        if(!this._keepLoginInterval && !this.keepLogin){
            this._keepLoginInterval = setInterval(() => {
                if(this.isDateTokenValid()){
                    let date = new Date();
                    this.setItem("date_token", date.toISOString());                    
                }
            }, 60000);
        }
    }

    isDateTokenValid(): boolean{
        let dateTokenString = this.getItem("date_token");
        if(dateTokenString != null && dateTokenString != undefined){
            let dateToCheck = new Date(dateTokenString);
            let date = new Date();
            if(isNaN(dateToCheck.getTime())){
                return false
            }else{
                if((date.getTime() - dateToCheck.getTime()) > 90000){
                    return false;
                }else{
                    return true;
                }
            }
        }else{
            return false;
        }
    }
}